/** @format */
import { Store } from "./Storage";

export const parseArray = (value: any | undefined) => {
	if (value) {
		return value;
	}
	return [];
};
export const mapStoreDataToPassportFields = (store: Partial<Store>) => {
	return {
		id: store.passportId,
		passport_strategies: store?.passport_strategies ?? "",
		passport_network: store?.passport_network ?? "",
		passport_signs: store?.passport_signs ?? "",
		passport_triggers: store?.passport_triggers ?? "",
		passport_impact: store?.passport_impact ?? "",
		passport_aspects: store?.passport_aspects ?? "",
		mh_issues_current: store?.mh_issues_current ?? "",
		mh_issues_past: store?.mh_issues_past ?? "",
		mh_challenges: store?.mh_challenges ?? "",
		neuro_details: parseArray(store?.neuro_details),
		neuro_diagnosed: store?.neuro_diagnosed ?? "",
		neuro_challenges: store?.neuro_challenges ?? "",
		wb_current: store?.wb_current ?? "",
		wb_past: store?.wb_past ?? "",
		wb_challenges: store?.wb_challenges ?? "",
		disabilty_details: store?.disabilty_details ?? "",
		disabilty_difficulties: store?.disabilty_difficulties ?? "",
		disabilty_challenges: store?.disabilty_challenges ?? "",
		profile_gp_details: store?.profile_gp_details ?? "",
		profile_support_network: store?.profile_support_network ?? "",
		profile_contacts: store?.profile_contacts ?? "",
		profile_support_services: store?.profile_support_services ?? "",
		profile_work: store?.profile_work ?? "",
		profile_dob: store?.profile_dob || null,
		profile_university: store?.profile_university ?? "",
		password: store?.password,
		passport_url: store?.passport_url || ""
	};
};

export const mapStoreDataToAssistantFields = (store: Partial<Store>) => {
	return {
		id: store.passportId,
		assistant_report: store?.assistant_report ?? "",
		files_keys: store?.files_keys ?? "",
		conditions_accepted: store?.conditions_accepted ?? null
	};
};


export const updatePassportAndWellbeingFormData = (data: Partial<Store>) => {
	const {
		id,
		password,
		...restData
	} = mapStoreDataToPassportFields(data);

	return restData;
};

export const arraysAreEqual = (arr1: any[], arr2: any[]) => {
	if (arr1.length !== arr2.length) {
		return false;
	}

	for (let i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) {
			return false;
		}
	}

	return true;
};